export default function CheckoutSkeleton() {
  return (
    <div className="p-15 space-y-5 h-[510px] animate-pulse">
      <div className="h-10 bg-gray-300 rounded"></div>
      <div className="h-10 bg-gray-300 rounded"></div>
      <div className="h-10 bg-gray-300 rounded"></div>
      <div className="h-10 bg-gray-300 rounded"></div>
      <div className="h-10 bg-gray-300 rounded"></div>

      <div className="grid grid-cols-2 gap-5">
        <div className="h-10 bg-gray-300 rounded col-span-1"></div>
        <div className="h-10 bg-gray-300 rounded"></div>
      </div>

      <div className="grid grid-cols-8 gap-5">
        <div className="h-10 bg-gray-300 rounded col-span-5"></div>
      </div>
    </div>
  );
}
